import zagUtils from './zag/zag-utils';
import utils from './conversion/utils';

class Header {

  constructor () {
      this.headerMobileMenu();
      this.toggleMobileResponsive();
      window.addEventListener('resize', this.toggleMobileResponsive.bind(this));
  };

  /****************************************************************
   HEADER MOBILE MENU
  ****************************************************************/
  headerMobileMenu () {
    document.querySelector('.mobile-trigger').addEventListener('click', function (e) {
        if (document.querySelector('.mobile-container').classList.contains('engaged') == false) {
          document.querySelector('.mobile-container').classList.add('engaged');
          document.querySelector('#header-search').classList.remove('collapse');
        }
        else {
          document.querySelector('.mobile-container').classList.remove('engaged');
          document.querySelector('.mobile-container').classList.add('disengaging');
          document.querySelector('#header-search').classList.add('collapse');
          window.setTimeout(function () {
            document.querySelector('.mobile-container').classList.remove('disengaging');
          }, 200);
        }
    });

    document.querySelector('.mobile-trigger > button').addEventListener('keypress', function (e) {
      if (e.keyCode == 13) {
        if (document.querySelector('.mobile-container').classList.contains('engaged') == false) {
          document.querySelector('.mobile-container').classList.remove('disengaged');
          document.querySelector('.mobile-container').classList.add('engaged');
        }
        else {
          document.querySelector('.mobile-container').classList.remove('engaged');
          document.querySelector('.mobile-container').classList.add('disengaging');
          window.setTimeout(function () {
            document.querySelector('.mobile-container').classList.remove('disengaging');
          }, 200);
        }
      }
    });
  };

  toggleMobileResponsive () {
    switch (zagUtils.GetCurrentBP()) {
      case 'sm':
      case 'xs':
        document.querySelector('#NavHeader').classList.add('mobile');
        document.querySelector('#NavHeader').classList.remove('main');
        document.querySelector('#NavHeader .nav-wrapper').classList.add('mobile-menu');
        document.querySelector('.header-olb .olb-headline-wrapper').setAttribute('tabindex', '0');
      break;
      default:
        if (!document.querySelector('#NavHeader').classList.contains('main')) {
          document.querySelector('#NavHeader').classList.add('main')
          document.querySelector('#NavHeader').classList.remove('mobile');
        }
        document.querySelector('#NavHeader .nav-wrapper').classList.remove('mobile-menu');
        document.querySelector('.header-olb .olb-headline-wrapper').setAttribute('tabindex', '-1');
      break;
    }
  };
}

document.addEventListener('DOMContentLoaded', () => {
  // HEADER NAV GLOBAL

  document.querySelectorAll('nav.global > ul > li.has-children > a').forEach((tgt) => {
    tgt.addEventListener('keyup', (e) => {
      if (e.keyCode === 9) {
        e.currentTarget.parentNode.classList.add('show');
        // e.currentTarget.parentNode.querySelector('span')?.focus();
      }
    })
  });

  document.querySelectorAll('nav.global > ul > li.has-children > ul > li:last-of-type').forEach((tgt) => {
    tgt.addEventListener('keydown', function (e) {
      if (e.keyCode === 9) {
        e.currentTarget.closest('.show').classList.remove('show');
      }
    });
  });

  document.body.addEventListener('click', function () {
    document.querySelectorAll('nav.global > ul > li.has-children').forEach((tgt) => {
      tgt.classList.remove('show');
    })
  });

  if (document.querySelector('nav.global > ul > li.has-children')) {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        document.querySelectorAll('nav.global > ul > li.has-children').forEach((tgt) => {
          tgt.classList.remove('show');
        });
      }
    });
  }
  // END HEADER NAV GLOBAL

  //
  if (document.querySelector('.header')) {
    const header = new Header();
  }

  // search focus
  document.querySelector('.search-toggle')?.addEventListener('click', () => {
    setTimeout(() => {
      document.querySelector('.search-dismiss').focus();
    }, 200)
  })
})
